// @flow
import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-FILTERS`

export default function ToursAndEventsFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const isActive = filters.hasUpcomingGatherings || filters.isTouring

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div data-pendo="toursAndEventsFilterButton">
      <FilterControl
        isActive={isActive}
        label={filterLabel()}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )

  function filterLabel() {
    if (filters.hasUpcomingGatherings && filters.isTouring) return t(`${PRE}-TOURS-AND-EVENTS`)
    if (filters.hasUpcomingGatherings) return t(`${PRE}-EVENTS`)
    if (filters.isTouring) return t(`${PRE}-TOURS`)

    return t(`${PRE}-TOURS-LABEL`)
  }
}
